import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  processes: [],
};

const processSlice = createSlice({
  name: "process",
  initialState,
  reducers: {
    updateProcess: (state, action) => {
      // // Check if the process with the given title exists
      // const existingProcessIndex = state.processes.findIndex(process => process.title === action.payload.title);

      // if (existingProcessIndex !== -1) {
      //   // Process exists: Update its days
      //   return {
      //     ...state,
      //     processes: state.processes.map((process, index) => {
      //       if (index === existingProcessIndex) {
      //         console.log("Title Matches - Updating Days");
      //         return {
      //           ...process,
      //           days: action.payload.newData.days,
      //           miterbiter:action.payload.newData.miterbiter
      //         };
      //       }
      //       return process;
      //     })
      //   };
      // } else {
      // Process doesn't exist: Create a new process
      console.log("Title Doesn't Match - Creating New Process");
      return {
        ...state,
        processes: [
          ...state.processes,
          {
            title: action.payload.title,
            days: action.payload.newData.days,
            miterbiter: action.payload.newData.miterbiter,
          },
        ],
      };
    },
  },
});

export const { updateProcess } = processSlice.actions;

export default processSlice.reducer;
